import { FullSpectacleData } from '@oe-backend/types';
import { environment } from '../../environments/environment';

export class Helper {
	public static parseJson(object: string): any | null {
		let parsedObject = null;
		try {
			parsedObject = JSON.parse(object);
		} catch (error) {
			console.log('Error while parsing the object: ' + error);
		}
		return parsedObject;
	}

	public static calculateSoonToBeDeletedFlag(createdDate: string | undefined): boolean {
		if (!createdDate) return false;
		return (
			new Date(createdDate).getTime() +
				1000 * 60 * 60 * 24 * environment.dayBeforeShowDeletionProductAlert <
			new Date().getTime()
		);
	}

	public static displayVrx(
		vrx: FullSpectacleData | undefined | null,
		prescriptions: FullSpectacleData | undefined | null,
	): boolean {
		return (
			vrx?.left?.addition !== prescriptions?.left?.addition ||
			vrx?.right?.addition !== prescriptions?.right?.addition ||
			vrx?.left?.axis !== prescriptions?.left?.axis ||
			vrx?.right?.axis !== prescriptions?.right?.axis ||
			vrx?.left?.cylinder !== prescriptions?.left?.cylinder ||
			vrx?.right?.cylinder !== prescriptions?.right?.cylinder ||
			vrx?.left?.sphere !== prescriptions?.left?.sphere ||
			vrx?.right?.sphere !== prescriptions?.right?.sphere
		);
	}

	public static sortDateAscending(a?: string, b?: string): number {
		const dateA = new Date(a || '').getTime();
		const dateB = new Date(b || '').getTime();
		if (dateA > dateB) return -1;
		if (dateA < dateB) return 1;
		return 0;
	}

	public static sortDateDescending(a?: string, b?: string): number {
		const dateA = new Date(a || '').getTime();
		const dateB = new Date(b || '').getTime();
		if (dateA < dateB) return -1;
		if (dateA > dateB) return 1;
		return 0;
	}
}
